'use strict';

/**
 *
 * @name: angularticsService
 *
 */

function AngularticsFactory($analytics, $rootScope, $location) {

  'ngInject';

  function pageTrack(data) {

    void 0;

    if (!data.pageTitle && (!$rootScope.seo || $rootScope.seo.pageTitle)) {

      data.pageTitle = 'NOWNESS';
    }

    var analyticsInputData = {
      page: {
        pageTitle: data.pageTitle || $rootScope.seo.pageTitle,
        sysEnv: ($rootScope.bWidth > 1024 ? 'desktop' : 'mobile'),
        // TODO: IMPLEMENT HONGKONG
        language: ($rootScope.lang === 'en-us' ? 'en' : 'cn'),
        country: ($rootScope.lang === 'en-us' ? 'EN' : 'CN'),
        geoRegion: ($rootScope.lang === 'en-us' ? 'EU' : 'AS'),
      },
      category: {
        primaryCategory: data.primaryCategory,
        subCategory1: data.subCategory1,
        subCategory2: data.subCategory2,
        pageType: data.pageType
      }
    };

    if (data.attributes) {

      analyticsInputData.attributes = data.attributes;
    }

    if (data.pageAttributes) {

      analyticsInputData.page.attributes = data.pageAttributes;
    }

    if (data.search) {

      analyticsInputData.page.onsiteSearchTerm = data.search.onsiteSearchTerm;
      analyticsInputData.page.onsiteSearchResult = data.search.onsiteSearchResult;
    }

    if ($rootScope.profile) {

      analyticsInputData.user = {
        id: $rootScope.profile.id,
        email: $rootScope.profile.email,
        segment: ($rootScope.profile.roles.indexOf('contributor') > -1 ? 'Contributors' : 'Existing Users')
      };
    }
    void 0;
    if (data.pageName) {

      $rootScope.analyticsFirstTime = false;
      return $analytics.pageTrack(data.pageName, analyticsInputData);
    } else {

      $rootScope.analyticsFirstTime = false;
      return $analytics.pageTrack($location.path(), analyticsInputData);
    }
  }

  return {
    pageTrack: pageTrack
  };
}

export default AngularticsFactory;



// WEBPACK FOOTER //
// ./app/components/nn-analytics/nn-angulartics.service.js